// 相当于接口，具体实现在 config-impl.jsx：通过 webpack 实现不同项目的 impl 替换
import { isHiddenFnImpl, replaceFnImpl, replaceTxtFnImpl, replaceDataFnImpl } from './config-impl-BESPOKE';

export const isHiddenFn = key => {
  return isHiddenFnImpl(key);
};

export const replaceFn = (key, value, props) => {
  return replaceFnImpl(key, value, props);
};

export const replaceTxtFn = (key, txt) => {
  return replaceTxtFnImpl(key, txt);
};

export const replaceDataFn = (key, originData) => {
  return replaceDataFnImpl(key, originData);
};
